import { Component, Input } from '@angular/core';
import { AmdSidenavService } from './sidenav.service';
var AmdSidenavComponent = /** @class */ (function () {
    /**
     * @param {?} amdSidenavService
     */
    function AmdSidenavComponent(amdSidenavService) {
        var _this = this;
        this.amdSidenavService = amdSidenavService;
        this.isOpen = false;
        this.amdSidenavService.sidenavToggled.subscribe(function (sidenavId) {
            if (sidenavId === _this.sidenavId) {
                _this.toggleSidenav();
            }
        });
        this.amdSidenavService.sidenavOpened.subscribe(function (sidenavId) {
            if (sidenavId === _this.sidenavId) {
                _this.openSidenav();
            }
        });
        this.amdSidenavService.sidenavClosed.subscribe(function (sidenavId) {
            if (sidenavId === _this.sidenavId) {
                _this.closeSidenav();
            }
        });
    }
    /**
     * @return {?}
     */
    AmdSidenavComponent.prototype.toggleSidenav = function () {
        this.isOpen = !this.isOpen;
    };
    /**
     * @return {?}
     */
    AmdSidenavComponent.prototype.openSidenav = function () {
        this.isOpen = true;
    };
    /**
     * @return {?}
     */
    AmdSidenavComponent.prototype.closeSidenav = function () {
        this.isOpen = false;
    };
    AmdSidenavComponent.decorators = [
        { type: Component, args: [{
                    selector: 'amd-sidenav',
                    template: "<div class=\"amd-sidenav\" [class.isOpen]=\"isOpen\"> <div class=\"amd-sidenav-backdrop\" (click)=\"closeSidenav()\"></div> <div class=\"amd-sidenav-content\"> <ng-content></ng-content> </div> </div>"
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdSidenavComponent.ctorParameters = function () { return [
        { type: AmdSidenavService, },
    ]; };
    AmdSidenavComponent.propDecorators = {
        'sidenavId': [{ type: Input },],
    };
    return AmdSidenavComponent;
}());
export { AmdSidenavComponent };
function AmdSidenavComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdSidenavComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdSidenavComponent.ctorParameters;
    /** @type {?} */
    AmdSidenavComponent.propDecorators;
    /** @type {?} */
    AmdSidenavComponent.prototype.sidenavId;
    /** @type {?} */
    AmdSidenavComponent.prototype.isOpen;
    /** @type {?} */
    AmdSidenavComponent.prototype.amdSidenavService;
}
//# sourceMappingURL=sidenav.component.js.map
//# sourceMappingURL=sidenav.component.js.map
